<div>
  <mat-icon style="color: #00cfb7;">check_circle</mat-icon>
  <span style="color: #00cfb7;">{{messageService.message.message}}</span>
</div>
